import { render, staticRenderFns } from "./receivelist.vue?vue&type=template&id=3c91dd44&"
import script from "./receivelist.vue?vue&type=script&lang=js&"
export * from "./receivelist.vue?vue&type=script&lang=js&"
import style0 from "./receivelist.vue?vue&type=style&index=0&id=3c91dd44&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports